import { cn } from "../../helpers"
import { body } from "../typography"

const button = (className?: string) =>
  cn(
    "inline-flex items-center gap-2 rounded-sm border-none p-[2px] text-blurple-500 outline-none transition-all duration-150 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blurple-600 focus-visible:ring-offset-2 hover:text-blurple-700",
    className,
  )
const buttonText = cn(body({ size: "link", className: "text-inherit" }))

export { button, buttonText }
